const STORE = {
    init: ()=> {
        global.MAD_STORE = {}
    },
    get(key){ 
        return global.MAD_STORE[key] 
    },
    set(key, value){ 
        global.MAD_STORE[key] = value 
    },
    get data() { 
        return global.MAD_STORE 
    },
}

export { STORE };